import React from 'react';

export type AlertType = 'info' | 'warning' | 'danger' | 'success';

interface AlertBlockProps {
  type: AlertType;
  icon?: string;
  heading?: string;
  onDismiss?: () => void;
  children?: React.ReactNode;
}

export function AlertBlock({ type, icon, heading, onDismiss, children }: AlertBlockProps) {
  return (
    <div className={`alert alert-${type} alert-block`}>
      {onDismiss && (
        <button type="button" className="close" aria-label="Dismiss" onClick={onDismiss}>
          <span aria-hidden="true">&times;</span>
        </button>
      )}
      {icon && <i className={`${icon} pull-left`} style={{ marginRight: 8 }} aria-hidden="true"></i>}
      {heading && <h4>{heading}</h4>}
      {children}
    </div>
  );
}
